import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import type { Control } from 'react-hook-form'
import { TextField } from '@chillout/ui'
import { SelectField } from '../../../../shared/SelectField'
import { AdminPill } from '../../../shared/AdminPill'

interface EditDeviceFormProps {
  control: Control<{ name: string; branchId: string }>
  branchOptions: { label: string; value: string }[]
  effectiveStatus: 'active' | 'inactive' | 'pending' | undefined
}

export function EditDeviceForm({ control, branchOptions, effectiveStatus }: EditDeviceFormProps) {
  const { t } = useTranslation()
  return (
    <>
      <Controller
        control={control}
        name="name"
        render={({ field, fieldState }) => (
          <TextField
            label={t('operations.addDevice.deviceNameLabel')}
            placeholder={t('operations.addDevice.deviceNamePlaceholder')}
            value={field.value}
            onChangeText={field.onChange}
            onBlur={field.onBlur}
            error={fieldState.error?.message}
          />
        )}
      />
      <Controller
        control={control}
        name="branchId"
        render={({ field }) => (
          <SelectField
            label={t('operations.addDevice.branchLabel')}
            placeholder={t('operations.addDevice.branchPlaceholder')}
            value={field.value}
            options={branchOptions}
            onValueChange={field.onChange}
          />
        )}
      />
      <View className="flex-row items-center justify-between">
        <Text className="text-sm font-medium text-primary">{t('operations.editDevice.statusLabel')}</Text>
        {effectiveStatus && (
          <AdminPill label={t(`operations.statuses.${effectiveStatus}`)} tone={effectiveStatus} />
        )}
      </View>
    </>
  )
}
